exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "div.form-employer[data-v-8a18bdc4]{height:100%}div.content[data-v-8a18bdc4]{padding-top:58px;padding-bottom:67px;background-color:#fff;min-height:100%}h3[data-v-8a18bdc4],h5[data-v-8a18bdc4]{color:#0c2340}", ""]);

// exports
